const types = {
  COACHING_LIST: "COACHING_LIST",
  COACHING_LIST_RESPONSE: "COACHING_LIST_RESPONSE",
  COACHING_LIST_CLEAR: "COACHING_LIST_CLEAR",

  CS_GETSKILL: "CS_GETSKILL",
  CS_GETSKILL_RESPONSE: "CS_GETSKILL_RESPONSE",
  CS_GETSKILL_CLEAR: "CS_GETSKILL_CLEAR",

  COACHING_REQUEST_SUBMIT: "COACHING_REQUEST_SUBMIT",
  COACHING_REQUEST_SUBMIT_RESPONSE: "COACHING_REQUEST_SUBMIT_RESPONSE",
  COACHING_REQUEST_SUBMIT_CLEAR: "COACHING_REQUEST_SUBMIT_CLEAR",

  GET_SLOTS: "GET_SLOTS",
  GET_SLOTS_RESPONSE: "GET_SLOTS_RESPONSE",
  GET_SLOTS_RESPONSE_CLEAR: "GET_SLOTS_RESPONSE_CLEAR",

  CREATE_SLOTS: "CREATE_SLOTS",
  CREATE_SLOTS_RESPONSE: "CREATE_SLOTS_RESPONSE",
  CREATE_SLOTS_RESPONSE_CLEAR: "CREATE_SLOTS_RESPONSE_CLEAR",

  ADD_SLOTS: "ADD_SLOTS",
  ADD_SLOTS_RESPONSE: "ADD_SLOTS_RESPONSE",
  ADD_SLOTS_RESPONSE_CLEAR: "ADD_SLOTS_RESPONSE_CLEAR",

  DELETE_SLOTS: "DELETE_SLOTS",
  DELETE_SLOTS_RESPONSE: "DELETE_SLOTS_RESPONSE",
  DELETE_SLOTS_RESPONSE_CLEAR: "DELETE_SLOTS_RESPONSE_CLEAR",

  GET_SESSION_NOTES_LISTING: "GET_SESSION_NOTES_LISTING",
  GET_SESSION_NOTES_LISTING_RESPONSE: "GET_SESSION_NOTES_LISTING_RESPONSE",
  GET_SESSION_NOTES_LISTING_RESPONSE_CLEAR:
    "GET_SESSION_NOTES_LISTING_RESPONSE_CLEAR",

  ADD_SESSION_NOTES: "ADD_SESSION_NOTES",
  ADD_SESSION_NOTES_RESPONSE: "ADD_SESSION_NOTES_RESPONSE",
  ADD_SESSION_NOTES_RESPONSE_CLEAR: "ADD_SESSION_NOTES_RESPONSE_CLEAR",

  REGISTER_COACH: "REGISTER_COACH",
  REGISTER_COACH_RESPONSE: "REGISTER_COACH_RESPONSE",
  REGISTER_COACH_RESPONSE_CLEAR: "REGISTER_COACH_RESPONSE_CLEAR",

  // Coaching Listing
  COACHING_LISTING: "COACHING_LISTING",
  COACHING_LISTING_RESPONSE: "COACHING_LISTING_RESPONSE",
  COACHING_LISTING_CLEAR: "COACHING_LISTING_CLEAR",

  COACH_RATING: "COACH_RATING",
  COACH_RATING_RESPONSE: "COACH_RATING_RESPONSE",
  COACH_RATING_RESPONSE_CLEAR: "COACH_RATING_RESPONSE_CLEAR",

  COACHING_PERSONAL_LISTING: "COACHING_PERSONAL_LISTING",
  COACHING_PERSONAL_LISTING_RESPONSE: "COACHING_PERSONAL_LISTING_RESPONSE",
  COACHING_PERSONAL_LISTING_CLEAR: "COACHING_PERSONAL_LISTING_CLEAR",

  GET_COACH_RATING: "GET_COACH_RATING",
  GET_COACH_RATING_RESPONSE: "GET_COACH_RATING_RESPONSE",
  GET_COACH_RATING_RESPONSE_CLEAR: "GET_COACH_RATING_RESPONSE_CLEAR",

  GET_MASTER_INDUSTRY_DATA: "GET_MASTER_INDUSTRY_DATA",
  GET_MASTER_INDUSTRY_DATA_RESPONSE: "GET_MASTER_INDUSTRY_DATA_RESPONSE",
  GET_MASTER_INDUSTRY_DATA_RESPONSE_CLEAR:
    "GET_MASTER_INDUSTRY_DATA_RESPONSE_CLEAR",

  GET_COACHING_SERVICES: "GET_COACHING_SERVICES",
  GET_COACHING_SERVICES_RESPONSE: "GET_COACHING_SERVICES_RESPONSE",
  GET_COACHING_SERVICES_RESPONSE_CLEAR: "GET_COACHING_SERVICES_RESPONSE_CLEAR",

  GET_COACHING_SERVICE_DETAIL: "GET_COACHING_SERVICE_DETAIL",
  GET_COACHING_SERVICE_DETAIL_RESPONSE: "GET_COACHING_SERVICE_DETAIL_RESPONSE",
  GET_COACHING_SERVICE_DETAIL_RESPONSE_CLEAR:
    "GET_COACHING_SERVICE_DETAIL_RESPONSE_CLEAR",

  COACHING_REQUEST_SEND: "COACHING_REQUEST_SEND",
  COACHING_REQUEST_SEND_RESPONSE: "COACHING_REQUEST_SEND_RESPONSE",
  COACHING_REQUEST_SEND_RESPONSE_CLEAR: "COACHING_REQUEST_SEND_RESPONSE_CLEAR",

  COACHING_REQUESTS_LIST: "COACHING_REQUESTS_LIST",
  COACHING_REQUESTS_LIST_RESPONSE: "COACHING_REQUESTS_LIST_RESPONSE",
  COACHING_REQUESTS_LIST_RESPONSE_CLEAR:
    "COACHING_REQUESTS_LIST_RESPONSE_CLEAR",

  RESCHEDULE_SLOTS: "RESCHEDULE_SLOTS",
  RESCHEDULE_SLOTS_RESPONSE: "RESCHEDULE_SLOTS_RESPONSE",
  RESCHEDULE_SLOTS_RESPONSE_CLEAR: "RESCHEDULE_SLOTS_RESPONSE_CLEAR",

  COACHING_REQUESTS_UPDATE: "COACHING_REQUESTS_UPDATE",
  COACHING_REQUESTS_UPDATE_RESPONSE: "COACHING_REQUESTS_UPDATE_RESPONSE",
  COACHING_REQUESTS_UPDATE_RESPONSE_CLEAR:
    "COACHING_REQUESTS_UPDATE_RESPONSE_CLEAR",

  GET_MY_BOOKING_LIST: "GET_MY_BOOKING_LIST",
  GET_MY_BOOKING_LIST_RESPONSE: "GET_MY_BOOKING_LIST_RESPONSE",
  GET_MY_BOOKING_LIST_RESPONSE_CLEAR: "GET_MY_BOOKING_LIST_RESPONSE_CLEAR",

  AI_COACHING_URL: "AI_COACHING_URL",
  AI_COACHING_URL_RESPONSE: "AI_COACHING_URL_RESPONSE",
  AI_COACHING_URL_RESPONSE_CLEAR: "AI_COACHING_URL_RESPONSE_CLEAR",
};

export default types;
